import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import {
  digitalRevenueList,
  npdList,
  metricsDigitalRevenueList,
  japanSalesSegOptions,
  japanSalesList,
  steamPCUFollowerListForSteamData,
  steamPCUFollowerList,
  steamPCUList,
  sourceSteamPCUList,
  alineaPCUList,
  gamalyticPCUList,
  metricsTablePCUList,
  metricsTablePCUFollwerList,
  // metricsTablePCUFollwerListOld,
  newZooRankList,
} from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { gsdSegmentList } from '@/pages/intelligence/pages/TopCharts/_config/gsdMetricsOptions';
// import { changeTimetoDay } from '@intelligence/utils/topchartsUtils';
import { IconList as commonIconList } from '@intelligence/components/CardSlotV2';
import {
  stackLineSeriesFormatter,
  lineSeriesFormatter,
  countriesBarSeriesFormatter,
  digitalPieSeriesFormatter,
  pieSeriesFormatter,
  countriesPCULineSeriesFormatter,
  countriesPCUBarSeriesFormatter,
  commonStackLineSeriesFormatter,
  getLocalizedCountryChartName,
  // lineSeriesAllMetricFormatter,
} from './_utils';
import {
  getCountryNameByCountryCode,
  newMathFormat,
} from '@/pages/intelligence/utils/commonUtils';
import { getDeviceName } from '@/pages/intelligence/components/Chart/_config/topchartsChartUtils';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { getIfPercentage } from '@/pages/intelligence/utils/common';
import { IconFourList } from '@/pages/intelligence/components/CardSlotV2';
import {
  assignDistinctSeriesColors,
  expandVisualMetricSeriesItems,
} from '@intelligence/pages/TopCharts/utils/multiValueMetricUtils';

const combineIconList = [
  {
    value: 'bar',
    icon: 'column-chart',
    context: 'dbi_bar_chart',
    disabled: false,
  },
  {
    value: 'line',
    icon: 'discount-chart',
    context: 'dbi_line_chart',
    disabled: false,
  },
  {
    value: 'stackedLine',
    icon: 'stack-diagram',
    context: 'dbi_stacked_line_chart',
    disabled: false,
  },
  {
    value: 'pie',
    icon: 'pie-chart-icon',
    context: 'dbi_pie_chart',
    disabled: false,
  },
];
const subdivideDeviceColor = {
  PC: '#326282',
  Xbox: '#4DAB7D',
  PlayStation: '#587EDB',
  Nintendo: '#F17C86',

  PlayStation4: '#3052B0',
  PlayStation5: '#587EDB',
  Xone: '#215E45',
  XXS: '#4DAB7D',
  NintendoWiiU: '#A64453',
  NintendoSwitch: '#F17C86',
};
const getSubdivideDeviceColor = (deviceName: string) => {
  switch (deviceName) {
    case 'pc':
    case 'PC':
      return subdivideDeviceColor.PC;

    case 'Xbox Series X|S':
    case 'Xbox':
      return subdivideDeviceColor.Xbox;

    case 'Nintendo Switch':
    case 'Nintendo':
      return subdivideDeviceColor.Nintendo;

    case 'PlayStation 5':
    case 'PlayStation':
      return subdivideDeviceColor.PlayStation;

    case 'PlayStation 4':
      return subdivideDeviceColor.PlayStation4;

    case 'Xbox One':
      return subdivideDeviceColor.Xone;

    case 'Nintendo Wii U':
      return subdivideDeviceColor.NintendoWiiU;

    default:
      return '';
  }
};
const getStatsCommonFirstColConfig = (params?: any) => {
  const { sumInfo } = params || {};
  return [
    {
      type: 'date',
      key: 'date',
      sortMetric: 'date',
      title: `dbi_date`,
      width: 180,
      sumInfo,
    },
  ];
};
const getCountriesCommonFirstColConfig = () => {
  return [
    {
      type: 'countries',
    },
  ];
};

const getnoData = (data: any[], metricList: any[]) => {
  try {
    for (let i = 0; i < data?.length; i++) {
      const dateItem = data[i];
      for (let j = 0; j < metricList?.length; j++) {
        const mItem = metricList[j];
        // 在dateItem的metrics中查找对应mItem的metric
        const metricItem = dateItem?.metrics?.find(
          (metric) => metric?.metric === mItem?.value,
        );
        // 如果找到对应的metric，检查其value是否为''
        if (metricItem && !!metricItem?.value) {
          return false;
        }
      }
    }
    return true;
  } catch (err) {
    return false;
  }
};

const getNoData = (data: any[], metric: { value: string }) => {
  try {
    for (let i = 0; i < data?.length; i++) {
      const dateItem = data[i];
      const metricItem = dateItem?.metrics?.find(
        (metricItem: any) => metricItem?.metric === metric.value,
      );
      // 如果找到对应的metric，检查其value是否为''
      if (metricItem?.value) {
        return false;
      }
    }
    return true;
  } catch (err) {
    return false;
  }
};

const visualHandleLineFun = {
  statsLineSeriesFormatter: (params: {
    list: any;
    legendMetric: string;
    isPercentLine?: boolean;
    earliestClickValue: string;
    dateType: string;
    titleNow: string;
    isTwoYAxis?: boolean;
  }) => {
    const {
      titleNow,
      list,
      legendMetric,
      isPercentLine = false,
      earliestClickValue,
      dateType,
      isTwoYAxis = false,
    } = params || {};
    if (!Array.isArray(list) || list?.length < 1) return [];

    const objTemp = [
      {
        id: titleNow,
        name: titleNow,
        history: lineSeriesFormatter?.({
          list: list || [],
          legendMetric,
          dateType,
          earliestClickValue,
          isPercentLine,
        }),
      },
    ];
    return {
      source: objTemp,
    };
  },
  statsLineSeriesAllMetricFormatter: (params: {
    list: any;
    legendMetric?: string;
    isPercentLine?: boolean;
    earliestClickValue?: string;
    dateType?: string;
    titleNow?: string;
    visuailsMetricValues?: any;
    formatMessage?: (descriptor: {
      id: string;
      defaultMessage?: string;
    }) => string;
  }) => {
    const { list, visuailsMetricValues = [], formatMessage } = params || {};

    if (
      !Array.isArray(list) ||
      list?.length < 1 ||
      !Array.isArray(visuailsMetricValues) ||
      visuailsMetricValues?.length < 1
    ) {
      return {
        source: [],
        noData: true,
      };
    }
    // if (!Array.isArray(visuailsMetricValues) || visuailsMetricValues?.length < 1) return [];

    const arr: any = [];

    const seriesMetricItems = expandVisualMetricSeriesItems(
      visuailsMetricValues,
      list,
      formatMessage,
    );

    // Process selected metrics (multi-value metrics expand to multiple series)
    seriesMetricItems?.forEach((itemPa: any) => {
      const metricObjList: any = [];
      list?.forEach((item: any) => {
        if (
          item.metrics &&
          Array.isArray(item.metrics) &&
          item.metrics?.length > 0
        ) {
          const obj =
            item.metrics?.find(
              (subItem: any) => subItem.metric == itemPa.value,
            ) || {};
          metricObjList.push({
            time: item.date,
            value:
              itemPa?.renderType === RenderType.GROWTH_ONLY
                ? obj.value * 100
                : obj.value,
          });
        } else {
          metricObjList.push({
            time: item.date,
            value: '',
          });
        }
      });
      arr.push({
        id: itemPa.value,
        name: itemPa.text,
        history: metricObjList,
      });
    });

    // Find and add truedata metrics automatically
    const truedataMetrics = new Set<string>();
    list?.forEach((item: any) => {
      if (item.metrics && Array.isArray(item.metrics)) {
        item.metrics.forEach((metric: any) => {
          const metricKey = metric?.metric;
          // truedata may come either via explicit source field or encoded in metric name
          const isTrueDataSource = metric?.source === 'truedata';
          const isTrueDataByName =
            typeof metricKey === 'string' && metricKey?.toLowerCase()?.includes('truedata');
          if ((isTrueDataSource || isTrueDataByName) && typeof metricKey === 'string' && metricKey) {
            truedataMetrics.add(metricKey);
          }
        });
      }
    });

    // Add truedata metrics that aren't already in the selected metrics
    truedataMetrics.forEach((metricValue: string) => {
      const isAlreadySelected = visuailsMetricValues.some(
        (item: any) => item.value === metricValue
      );

      if (!isAlreadySelected) {
        const metricObjList: any = [];
        list?.forEach((item: any) => {
          if (
            item.metrics &&
            Array.isArray(item.metrics) &&
            item.metrics?.length > 0
          ) {
            const obj =
              item.metrics?.find(
                (subItem: any) =>
                  subItem.metric === metricValue &&
                  (
                    subItem.source === 'truedata' ||
                    (typeof subItem.metric === 'string' && subItem.metric.toLowerCase().includes('truedata'))
                  ),
              ) || {};
            metricObjList.push({
              time: item.date,
              value: obj.value,
            });
          } else {
            metricObjList.push({
              time: item.date,
              value: '',
            });
          }
        });

        arr.push({
          id: metricValue,
          name: metricValue, // You might want to customize this name
          history: metricObjList,
        });
      }
    });

    // Filter out series whose history values are all zero/empty
    const isNonZero = (val: any) => {
      if (val === '' || val === undefined || val === null) return false;
      const num = Number(val);
      return !Number.isNaN(num) && num !== 0;
    };

    const filteredArr = (arr || []).filter((series: any) =>
      series?.history?.some((p: any) => isNonZero(p?.value)),
    );

    // compute noData based on actual non-zero series values present
    const noData = !(filteredArr || []).some((series: any) =>
      series?.history?.some((p: any) => isNonZero(p?.value)),
    );

    const coloredArr = assignDistinctSeriesColors(filteredArr);

    return {
      source: coloredArr,
      noData,
    };
  },

  statsLineSeriesAllMetricKPITrendsFormatter: (params: {
    list: any;
    legendMetric?: string;
    isPercentLine?: boolean;
    earliestClickValue?: string;
    dateType?: string;
    titleNow?: string;
    visualMetricValues?: any;
  }) => {
    const { list, visualMetricValues = {} } = params || {};

    if (!Array.isArray(list) || list?.length < 1) {
      return {
        source: [],
        noData: true,
      };
    }

    const noDataLegacy = getNoData(list, visualMetricValues);
    const arr: any = [];

    const metricObjList: any = [];

    list?.forEach((item: any) => {
      if (
        item.metrics &&
        Array.isArray(item.metrics) &&
        item.metrics?.length > 0
      ) {
        const obj =
          item.metrics?.find(
            (subItem: any) => subItem.metric === visualMetricValues.value,
          ) || {};

        metricObjList.push({
          time: item.date,
          value:
            visualMetricValues?.renderType === RenderType.GROWTH_ONLY
              ? obj.value * 100
              : obj.value,
        });
      } else {
        metricObjList.push({
          time: item.date,
          value: '',
        });
      }
    });

    arr.push({
      id: visualMetricValues.value,
      name: visualMetricValues.text,
      history: metricObjList,
    });

    // Treat all-zero series as no data and filter them out
    const isNonZero = (val: any) => {
      if (val === '' || val === undefined || val === null) return false;
      const num = Number(val);
      return !Number.isNaN(num) && num !== 0;
    };

    const filteredArr = (arr || []).filter((series: any) =>
      series?.history?.some((p: any) => isNonZero(p?.value)),
    );

    const noData = filteredArr.length === 0 || noDataLegacy;

    return {
      source: filteredArr,
      noData,
    };
  },

  pcuStatsLineSeriesFormatter: (
    params: {
      list: any;
      legendMetric: string;
      isPercentLine?: boolean;
      earliestClickValue: string;
      dateType: string;
      titleNow: string;
    },
    segementList: any[],
  ) => {
    const {
      titleNow,
      list,
      legendMetric,
      isPercentLine = false,
      earliestClickValue,
      dateType,
    } = params || {};
    if (!Array.isArray(list) || list?.length < 1) return [];

    const arrGameData: any = [];

    segementList?.forEach((opt: any) => {
      const objTemp = {
        id: opt?.value,
        name: opt?.textStr || opt?.text,
        // 透传数据源，便于上层在 legend 名前拼接数据源名（如 "Alinea Analytics Steam PCU"）
        dataSource: opt?.dataSource,
        history: lineSeriesFormatter?.({
          list: list || [],
          legendMetric: opt?.value,
          dateType,
          earliestClickValue,
          isPercentLine,
        }),
      };
      arrGameData.push(objTemp);
    });
    const temp = {
      source: Array.isArray(arrGameData) ? arrGameData : [],
    };
    return temp;
  },
  digitalStatsStackLineSeriesFormatter: (params: {
    list: any;
    legendMetric: string;
    isPercentLine?: boolean;
    earliestClickValue: string;
    dateType: string;
  }) => {
    const {
      list,
      legendMetric,
      isPercentLine = false,
      earliestClickValue,
      dateType,
    } = params || {};

    if (!Array.isArray(list) || list?.length < 1) return [];
    const objTemp = stackLineSeriesFormatter?.({
      list: list || [],
      legendMetric,
      dateType,
      earliestClickValue,
      isPercentLine,
    });
    return {
      source: objTemp,
    };
  },
  statsStackLineSeriesFormatter: (params: {
    list: any;
    legendMetric: string;
    isPercentLine?: boolean;
    earliestClickValue: string;
    dateType: string;
  }) => {
    const {
      list,
      legendMetric,
      isPercentLine = false,
      earliestClickValue,
      dateType,
    } = params || {};

    const objTemp = commonStackLineSeriesFormatter?.({
      list: list || [],
      legendMetric,
      dateType,
      earliestClickValue,
      isPercentLine,
    });
    return {
      source: objTemp,
    };
  },
  countriesLineSeriesFormatter: (params: {
    list: any;
    legendMetric: string;
    isPercentLine?: boolean;
    earliestClickValue: string;
    dateType: string;
    regionsCountries: any[];
    localizedOthersName?: string;
  }) => {
    const {
      list,
      legendMetric,
      isPercentLine = false,
      earliestClickValue,
      dateType,
      regionsCountries,
      localizedOthersName,
    } = params || {};
    const arrGameData: any = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const n in list) {
      const gameObj = list[n];
      const nameStr = gameObj?.market || gameObj?.name || '';
      const countryName = getLocalizedCountryChartName({
        regionsCountries,
        countryCode: gameObj?.market,
        fallbackName: nameStr,
        localizedOthersName,
      });
      const objTemp = {
        cover: gameObj.market,
        id: gameObj.market,
        // name: ((gameObj?.name === 'global') || (gameObj?.market === 'global')) ? 'Global' : (gameObj?.name || gameObj?.market),
        name: countryName,
        history: lineSeriesFormatter?.({
          list: gameObj?.history || gameObj?.time_line || [],
          legendMetric,
          dateType,
          earliestClickValue,
          isPercentLine,
        }),
      };
      arrGameData.push(objTemp);
    }
    const noData = !arrGameData.length;
    const temp = {
      source: Array.isArray(arrGameData) ? arrGameData : [],
      noData,
    };
    return temp;
  },
  countriesBarSeriesFormatter,
  digitalPieSeriesFormatter,
  pieSeriesFormatter,
  countriesPCULineSeriesFormatter,
  countriesPCUBarSeriesFormatter,
  commonBarNameListFormatter: (params: {
    barData: any[];
  }) => {
    const { barData } = params;
    return (
      barData?.map((item: any) => {
        const nameStr = item?.market || item?.name || '';
        return nameStr;
      }) || []
    );
  },
  pcuBarNameListFormatter: (params: { list: any[] }) => {
    const { list } = params;
    return (
      list?.map((item: any) => {
        return item?.textStr || item?.text;
      }) || []
    );
  },
  commonPieSeriesCountriesFormatter: (params: {
    pieData: any;
    legendMetric: string;
    regionsCountries: any[];
  }) => {
    const { pieData, legendMetric, regionsCountries } = params || {};

    if (!Array.isArray(pieData) || pieData?.length < 1) return [];
    const piList: any = [];
    let sum = 0;
    pieData?.forEach((item: any, i: any) => {
      const metricNum = item?.metrics
        ? item.metrics?.find((item: any) => item?.metric == legendMetric)?.value
        : 0;
      const nameStr = item?.name || item?.market || '';
      const objTemp = {
        app_id: item.market,
        name: getCountryNameByCountryCode(regionsCountries, nameStr),
        value: metricNum,
      };
      sum += metricNum;
      piList.push(objTemp);
    });
    return piList;
  },
  commonPieSeriesHoverFormatter: (params: {
    pieData: any;
    legendMetric: string;
    isCountriesPage?: boolean;
    regionsCountries: any[];
    byDevice?: boolean;
    titleNow?: string;
  }) => {
    const {
      pieData,
      legendMetric,
      isCountriesPage,
      regionsCountries,
      byDevice,
      titleNow,
    } = params || {};

    const pieList: any = [];
    if (!pieData) return pieList;
    if (Array.isArray(pieData) && pieData?.length > 0) {
      if (isCountriesPage) {
        const metricList =
          pieData[0].metrics && Array.isArray(pieData[0].metrics)
            ? pieData[0].metrics
            : [];
        const itemCountry = metricList?.find(
          (t: any) => t?.metric == legendMetric,
        );
        pieList.push({
          value: itemCountry?.value,
          name: getCountryNameByCountryCode(
            regionsCountries,
            pieData[0].market || '',
          ),
          name_zh: getCountryNameByCountryCode(
            regionsCountries,
            pieData[0].market || '',
          ),
          market: pieData[0].market || '',
        });
      } else {
        const deviceItem = pieData?.find((t: any) => t?.metric == legendMetric);
        pieList.push({
          value: deviceItem?.value,
          name: !byDevice ? titleNow : 'All',
          name_zh: !byDevice ? titleNow : '全部',
        });
      }
    }
    return pieList;
  },
  commonStackBarSeriesFormatter: (params: {
    barData: any;
    legendMetric: string;
    sourceListParams: string[];
  }) => {
    const { barData, legendMetric, sourceListParams } = params || {};

    const _barSeries: any = [];
    if (!Array.isArray(barData) || barData?.length < 1) {
      return _barSeries;
    }

    // 处理空数据
    // let sourceList: any = [];

    // for (let n in barData) {
    //   if (barData[n].metric_device) {
    //     sourceList = Object.keys(barData[n].metric_device) || [];
    //     // return;
    //   }
    // }

    // 有传入 sourceList 使用传入的值（避免 countries user engagement 页按原有逻辑首项 device 数据不齐导致后面数据也没有 device）
    const sourceList =
      sourceListParams ||
      (barData?.[0]?.metric_device
        ? Object.keys(barData[0].metric_device)
        : []);

    // 想排序要在处理前排序
    sourceList?.forEach((item: any) => {
      const dataVal: any = []; // 通过下标拿值
      barData?.forEach((t: any) => {
        const keyObjArr = t.metric_device[item];
        const deviceItem = Array.isArray(keyObjArr)
          ? keyObjArr.find((item) => item.metric == legendMetric)
          : {};
        dataVal.push({
          value: deviceItem?.value,
          name: getDeviceName(deviceItem?.device),
          market: t?.market,
        });
      });

      _barSeries.push({
        name: getDeviceName(item),
        type: 'bar',
        stack: 'total',
        data: dataVal,
        barMaxWidth: 92,
      });
    });

    const getSumValues = (data, index) => {
      if (!Array.isArray(data)) {
        return 0;
      }
      let total = 0;
      for (const item of data) {
        if (index < item?.data?.length) {
          const val = Number(item?.data?.[index]?.value);
          if (!isNaN(val)) {
            total += item?.data?.[index]?.value;
          }
        }
      }
      return total;
    };

    const sumBarSeries = [];
    _barSeries.forEach((t) => {
      sumBarSeries.push({
        ...t,
        label: {
          // show: sourceList.length === idx + 1,
          show: true,
          position: 'top',
          color: '#444',
          distance: 4,
          fontSize: 12,
          formatter: (params: any) => {
            // 获取当前柱子的数据
            const { dataIndex, seriesName } = params || {};

            // 获取当前柱对应的所有有效 series
            const currentSeriesCurrentBarData = _barSeries.map(
              (series: any) => series?.data?.[dataIndex],
            );
            const visibleStackBar = currentSeriesCurrentBarData
              ?.map((item: any) => item?.name)
              ?.filter(Boolean);

            // 当前的柱的当前堆叠 series 柱，是否是最后一项顶部堆叠柱 series
            const isNotTopStackBar =
              seriesName !== visibleStackBar[visibleStackBar.length - 1];

            // 不是最顶部的堆叠柱，不需要显示
            if (isNotTopStackBar) return '';

            const sum = getSumValues(_barSeries, dataIndex);
            return `${
              newMathFormat(Number(sum), true) +
              (getIfPercentage(legendMetric) ? '%' : '')
            }`;
          },
        },
      });
    });

    return sumBarSeries;
  },
  commonStackPieSeriesFormatter: (params: {
    pieData: any;
    legendMetric: string;
  }) => {
    const { pieData, legendMetric } = params || {};

    const pieList: any = [];
    if (!pieData) return pieList;
    if (Object.keys(pieData).length > 0) {
      const sourceList = Object.keys(pieData);
      sourceList.forEach((item: any) => {
        const valueList =
          Array.isArray(pieData[item]) && pieData[item]?.length > 0
            ? pieData[item]
            : [];
        const deviceItem = valueList?.find(
          (t: any) => t.metric == legendMetric,
        );
        pieList.push({
          value: deviceItem?.value,
          name: getDeviceName(deviceItem?.device),
          name_zh: getDeviceName(deviceItem?.device),
          color: getSubdivideDeviceColor(item),
        });
      });
    }
    return pieList;
  },

  countriesDigitalRevenueStackBarSeriesFormatter: (params: {
    barData: any;
    legendMetric: string;
    sourceListParams?: string[];
  }) => {
    const { barData, legendMetric, sourceListParams } = params || {};

    const _barSeries: any = [];
    if (!Array.isArray(barData) || barData?.length < 1) {
      return _barSeries;
    }

    const sourceList = sourceListParams?.length
      ? sourceListParams
      : Array.from(
        new Set(
          barData.flatMap((item: any) => Object.keys(item?.metric_device || {})),
        ),
      );

    // 想排序要在处理前排序
    sourceList?.forEach((item: any) => {
      const dataVal: any = []; // 通过下标拿值
      barData?.forEach((t: any) => {
        const keyObjArr = t.metric_device[item];
        const deviceItem = Array.isArray(keyObjArr)
          ? keyObjArr.find((item) => item.metric == legendMetric)
          : {};
        dataVal.push({
          value: deviceItem?.value,
          name: getDeviceName(deviceItem?.device),
          market: t?.market,
        });
      });

      _barSeries.push({
        name: getDeviceName(item),
        type: 'bar',
        stack: 'total',
        data: dataVal,
        barMaxWidth: 92,
      });
    });

    const getSumValues = (data: any, index: any) => {
      if (!Array.isArray(data)) {
        return 0;
      }
      let total = 0;
      for (const item of data) {
        if (index < item?.data?.length) {
          const val = Number(item?.data?.[index]?.value);
          if (!isNaN(val)) {
            total += val;
          }
        }
      }
      return total;
    };

    const sumBarSeries: any[] = [];
    _barSeries.forEach((t: any) => {
      const item = {
        itemStyle: {},
        ...t,
        label: {
          show: true,
          position: 'top',
          color: '#444',
          distance: 4,
          fontSize: 12,
          formatter: (params: any) => {
            const { dataIndex, seriesName } = params || {};
            const topSeriesName = [..._barSeries]
              .reverse()
              .find((series: any) => {
                const value = series?.data?.[dataIndex]?.value;
                return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
              })?.name;

            if (seriesName !== topSeriesName) return '';

            const sum = getSumValues(_barSeries, dataIndex);
            return `${
              newMathFormat(Number(sum), true) +
              (getIfPercentage(legendMetric) ? '%' : '')
            }`;
          },
        },
      };
      item.itemStyle = {
        ...item.itemStyle,
        color: getSubdivideDeviceColor(item?.name),
      };
      sumBarSeries.push(item);
    });
    return sumBarSeries;
  },

  digitalStatsStackLineSeriesFormatterByDevice: (params: {
    list: any;
    legendMetric: string;
    isPercentLine?: boolean;
    earliestClickValue: string;
    dateType: string;
  }) => {
    const {
      list,
      legendMetric,
      isPercentLine = false,
      earliestClickValue,
      dateType,
    } = params || {};
    if (!Array.isArray(list) || list?.length < 1) return [];
    let objTemp = stackLineSeriesFormatter?.({
      list: list || [],
      legendMetric,
      dateType,
      earliestClickValue,
      isPercentLine,
    });
    Array.isArray(objTemp) &&
      objTemp?.forEach((item) => {
        if (item?.name) {
          item.color = getSubdivideDeviceColor(item?.name);
        }
      });

    // 判断获取当前是否有数据
    let noData = true;
    for (const item of objTemp) {
      const hasValue = item?.history?.find(
        (item: { value: any }) => !['', undefined, null].includes(item?.value),
      );
      if (hasValue) {
        noData = false;
        break;
      }
    }
    // 过滤掉不存在的数据
    objTemp = objTemp?.filter((key) =>
      key?.history?.find(
        (item: { value: any }) => !['', undefined, null].includes(item?.value),
      ),
    );
    return {
      source: objTemp,
      noData,
    };
  },

  getDeviceColorStackPieSeriesFormatter: (params: {
    pieData: any;
    legendMetric: string;
  }) => {
    const { pieData, legendMetric } = params || {};

    const pieList: any = [];
    if (!pieData) return pieList;
    if (Object.keys(pieData).length > 0) {
      const sourceList = Object.keys(pieData);
      sourceList.forEach((item: any) => {
        const valueList =
          Array.isArray(pieData[item]) && pieData[item]?.length > 0
            ? pieData[item]
            : [];
        const deviceItem = valueList?.find(
          (t: any) => t.metric == legendMetric,
        );
        const name = getDeviceName(deviceItem?.device || item);
        pieList.push({
          value: deviceItem?.value,
          name: getDeviceName(deviceItem?.device || item),
          name_zh: getDeviceName(deviceItem?.device || item),
          color: getSubdivideDeviceColor(name),
        });
      });
    }
    return pieList;
  },
};

const tableMetricValueOfCvm = {
  // PCU,Physical, digital, steamsale-stats
  common: (cvm: any, metricKey: string) => {
    if (!cvm || !metricKey) {
      return {};
    }
    const metrics = Array.isArray(cvm?.metrics) ? cvm?.metrics : [];
    const metric = metrics?.find((item: any) => {
      const nameStr = item?.name || item?.metric;
      return nameStr === metricKey;
    });
    if (!metric) {
      return {};
    }
    // a（0） || b（undefined) = undefined
    return { ...metric, growth_ratio: metric?.growth_ratio ?? metric?.dod };
  },
  countriesSteamSale: (cvm: any, metricKey: string, metricProperty: string) => {
    // metricProperty:   isPlayerbyCountry ? 'name' : 'metric';
    if (!cvm || !metricKey) {
      return {};
    }
    const metrics = Array.isArray(cvm?.metrics) ? cvm?.metrics : [];
    const metric = metrics?.find(
      (item: any) => item?.[metricProperty] === metricKey,
    );
    if (!metric) {
      return {};
    }
    return { ...metric, growth_ratio: metric?.dod };
  },
};

const localizedCountryName = (
  cvm: any,
  locale: string,
  regionsCountries?: any[],
) => {
  const isCn = locale === 'zh-CN';
  const localized = getCountryNameByCountryCode(
    regionsCountries || [],
    cvm?.market,
  );
  if (localized && localized !== cvm?.market) {
    return localized;
  }
  if (isCn) {
    return cvm?.name_cn || cvm?.name;
  }
  return cvm?.name;
};

// const getHasDeviceBtn = (chartType: string) => {
//   return chartType === ChartType.Bar;
// };
export type pageCfgType = {
  cardTitle: string; // 卡片标题
  segementList?: any[];
  disableChartType: string[]; // 可视化：柱、折、饼
  sumAvgMax: any;
  defaultChartType: string;
  chartIconList?: any[];
  tableMetricList: any[]; // 表格头部指标列表
  firstCol: any[]; // 表格第一列
  specialCol: any[]; // 表格最后特殊列
  getMetricValueOfCvm: (cvm: any, metricKey: string) => any;
  growthHasPoint?: string; // 表格环比数据小数点保留位数
  pageSizeOptions: number[];
  getDefaultPageSize: Function;
  defaultPageSize?: number;
  // 表格用于排序拿值的指标字段
  tableSortMetricProperty: string;
  tableSortGrowthProperty: string;
  localizedCountryName?: Function;
  lineMetricName: string;
  visualisLineTopChartsType: string;
  lineSeriesFormatter: Function;
  barSeriesFormatter: Function;
  barNameListFormatter: Function;
  pieSeriesFormatter: Function;
  stackLineSeriesFormatter: Function;
  stackBarSeriesFormatter: Function;
  stackPieSeriesFormatter: Function;
  visualisBarTopChartsType: string;
  enableAutoBarWidth?: boolean;
  visualisPieTopChartsType: string;
  sumavgArr?: string[]; // 页面配置里有则用配置里的，否则用指标配置里的
};

const statsPageSizeOptions = [10, 20, 30, 50, 100, 200];
// const commonPageSizeOptions = [5, 10, 15];
const commonPageSizeOptions = [10, 20, 30, 50, 100, 200];

const getDefaultPageSize = (dateType: string) => {
  return 50;
  // const type = changeTimetoDay(dateType);
  // if (type === 'day') {
  //   return 50;
  // }
  // return 10;
};

const commonPCConsoleStatsConfig = {
  pcu: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_trends_pcu',
    // disableChartType: [ChartType.Bar],
    segementList: [],
    defaultSegmentVal: '',
    defaultByDeviceVal: false,
    tableMetricList: metricsTablePCUFollwerList,
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-pcu',
    lineSeriesFormatter: (params: any) =>
      visualHandleLineFun.pcuStatsLineSeriesFormatter(
        params,
        metricsTablePCUFollwerList,
      ),
    stackLineSeriesFormatter: visualHandleLineFun.statsStackLineSeriesFormatter,
  },
  gsd: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_trends_gsd',
    defaultByDeviceVal: false,
    // disableChartType: [ChartType.Bar],
    segementList: gsdSegmentList,
    defaultSegmentVal: gsdSegmentList[0]?.value,
    // 表格配置
    tableMetricList: gsdSegmentList,
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    // 可视化配置
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter:
      visualHandleLineFun.digitalStatsStackLineSeriesFormatter,
    pieSeriesFormatter: () => {}, // TODO
    stackPieSeriesFormatter: () => {}, // TODO
  },
  digitalRevenue: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_trends_digital',
    defaultByDeviceVal: false,
    // disableChartType: [ChartType.Bar],
    segementList: digitalRevenueList,
    defaultSegmentVal: digitalRevenueList[0]?.value,
    // 表格配置
    tableMetricList: digitalRevenueList,
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    // 可视化配置
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter:
      visualHandleLineFun.digitalStatsStackLineSeriesFormatter,
    pieSeriesFormatter: () => {}, // TODO
    stackPieSeriesFormatter: () => {}, // TODO
  },
  physicalRevenue: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_trends_physical',
    defaultByDeviceVal: false,
    // disableChartType: [ChartType.Bar],
    segementList: npdList,
    defaultSegmentVal: npdList[0]?.value,
    tableMetricList: npdList,
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter:
      visualHandleLineFun.digitalStatsStackLineSeriesFormatter,
    pieSeriesFormatter: () => {}, // TODO
    stackPieSeriesFormatter: () => {}, // TODO
  },
  steamData: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: '',
    defaultByDeviceVal: false,
    segementList: [],
    defaultSegmentVal: '',
    tableMetricList: [],
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter: visualHandleLineFun.statsStackLineSeriesFormatter,
  },
  consoleData: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: '',
    defaultByDeviceVal: false,
    segementList: [],
    defaultSegmentVal: '',
    tableMetricList: [],
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter: visualHandleLineFun.statsStackLineSeriesFormatter,
  },
  japanSales: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_trends_japansales',
    defaultByDeviceVal: false,
    // disableChartType: [ChartType.Bar],
    segementList: japanSalesSegOptions,
    defaultSegmentVal: japanSalesSegOptions[0]?.value,
    tableMetricList: japanSalesList,
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source', // 外面处理
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter: visualHandleLineFun.statsStackLineSeriesFormatter,
    pieSeriesFormatter: () => {}, // TODO
    stackPieSeriesFormatter: () => {}, // TODO
  },
  newzoo: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Line,
    cardTitle: '',
    defaultByDeviceVal: false,
    // disableChartType: [ChartType.Bar],
    segementList: [],
    defaultSegmentVal: '',
    tableMetricList: [],
    firstCol: getStatsCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: statsPageSizeOptions,
    getDefaultPageSize,
    tableSortMetricProperty: 'name',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line',
    lineSeriesFormatter: visualHandleLineFun.statsLineSeriesFormatter,
    stackLineSeriesFormatter: visualHandleLineFun.statsStackLineSeriesFormatter,
    pieSeriesFormatter: () => {}, // TODO
    stackPieSeriesFormatter: () => {}, // TODO
  },
};
const commonePCConsoleCountriesConfig = {
  pcu: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_countries_pcu',
    disableChartType: [ChartType.Pie],
    segementList: [],
    defaultSegmentVal: '',
    // Countries/PCU 表格在 VGI PCU/ACU 的基础上增加 Source Steam + Alinea + Gamalytic 同名指标列
    // - 仅影响表格列；可视化使用的 series 形成器也按最新的指标集合来
    tableMetricList: [
      ...sourceSteamPCUList,
      ...alineaPCUList,
      ...gamalyticPCUList,
      ...metricsTablePCUList,
    ],
    defaultByDeviceVal: false,
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-pcu',
    visualisBarTopChartsType: 'pcconsole-country-bar-pcu',
    lineSeriesFormatter: (params: any) =>
      visualHandleLineFun.countriesPCULineSeriesFormatter(
        params,
        [...sourceSteamPCUList, ...alineaPCUList, ...gamalyticPCUList],
      ),
    barSeriesFormatter: (params: any) =>
      visualHandleLineFun.countriesPCUBarSeriesFormatter(
        params,
        [...sourceSteamPCUList, ...alineaPCUList, ...gamalyticPCUList],
      ),
    barNameListFormatter: () =>
      visualHandleLineFun.pcuBarNameListFormatter({
        list: [...sourceSteamPCUList, ...alineaPCUList, ...gamalyticPCUList],
      }),
    stackBarSeriesFormatter: () => {}, // TODO
  },
  gsd: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Bar,
    cardTitle: 'dbi_countries_gsd',
    // disableChartType: [],
    defaultByDeviceVal: false,
    segementList: gsdSegmentList,
    defaultSegmentVal: gsdSegmentList[0]?.value,
    tableMetricList: gsdSegmentList,
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    visualisBarTopChartsType: 'pcconsole-country-bar',
    enableAutoBarWidth: true,
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.pieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {}, // TODO
  },
  digitalRevenue: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_countries_digital',
    // disableChartType: [],
    defaultByDeviceVal: false,
    segementList: metricsDigitalRevenueList,
    defaultSegmentVal: metricsDigitalRevenueList[0]?.value,
    tableMetricList: metricsDigitalRevenueList,
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    visualisBarTopChartsType: 'pcconsole-country-bar',
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.digitalPieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {}, // TODO
  },
  physicalRevenue: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_countries_physical',
    disableChartType: [ChartType.Pie],
    segementList: npdList,
    defaultSegmentVal: npdList[0]?.value,
    defaultByDeviceVal: false,
    tableMetricList: npdList,
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'growth_ratio',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    visualisBarTopChartsType: 'pcconsole-country-bar',
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.digitalPieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {}, // TODO
  },
  steamData: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_detail_countries_share',
    // disableChartType: [],
    segementList: [],
    defaultSegmentVal: '',
    defaultByDeviceVal: false,
    tableMetricList: [],
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [],
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'dod',
    getMetricValueOfCvm: tableMetricValueOfCvm.countriesSteamSale,
    localizedCountryName,
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    visualisBarTopChartsType: 'pcconsole-country-bar',
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.pieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {}, // TODO
  },
  japanSales: {
    chartIconList: commonIconList,
    defaultChartType: ChartType.Line,
    cardTitle: 'dbi_countries_japansales',
    defaultByDeviceVal: false,
    // disableChartType: [ChartType.Pie],
    segementList: japanSalesSegOptions,
    defaultSegmentVal: japanSalesSegOptions[0]?.value,
    tableMetricList: japanSalesList,
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'metric',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    visualisBarTopChartsType: 'pcconsole-country-bar',
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.pieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {}, // TODO
  },
  newzoo: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Bar,
    cardTitle: 'dbi_detail_countries_share',
    defaultByDeviceVal: false,
    // disableChartType: [], //每个指标可能不一样
    segementList: [],
    defaultSegmentVal: '',
    tableMetricList: [],
    firstCol: getCountriesCommonFirstColConfig(),
    specialCol: [{ type: 'rank', ...newZooRankList[0] }],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'name',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    visualisBarTopChartsType: 'pcconsole-country-bar',
    enableAutoBarWidth: true,
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.pieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {},
  },
  ampere: {
    chartIconList: IconFourList,
    defaultChartType: ChartType.Bar,
    cardTitle: 'dbi_detail_countries_share',
    defaultByDeviceVal: false,
    // disableChartType: [], //每个指标可能不一样
    segementList: [],
    defaultSegmentVal: '',
    tableMetricList: [],
    firstCol: getCountriesCommonFirstColConfig(),
    // countries 这里不需要 rank 列
    // specialCol: [{ type: 'rank', ...newZooRankList[0] }],
    getMetricValueOfCvm: tableMetricValueOfCvm.common,
    pageSizeOptions: commonPageSizeOptions,
    // defaultPageSize: 15,
    defaultPageSize: 50,
    tableSortMetricProperty: 'name',
    tableSortGrowthProperty: 'dod',
    lineMetricName: 'source',
    visualisLineTopChartsType: 'pcconsole-stats-line-country',
    // visualisBarTopChartsType: 'pcconsole-country-bar',
    visualisBarTopChartsType: 'pcconsole-country-ampere-bar',
    lineSeriesFormatter: visualHandleLineFun.countriesLineSeriesFormatter,
    barSeriesFormatter: visualHandleLineFun.countriesBarSeriesFormatter,
    pieSeriesFormatter: visualHandleLineFun.pieSeriesFormatter,
    barNameListFormatter: visualHandleLineFun.commonBarNameListFormatter,
    stackBarSeriesFormatter: () => {},
  },
};
const configurations = {
  mobile: {
    stats: {},
    countries: {},
  },
  pc: {
    stats: {
      pcu: {
        ...commonPCConsoleStatsConfig.pcu,
        disableChartType: [ChartType.Bar, ChartType.Line],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      gsd: {
        ...commonPCConsoleStatsConfig.gsd,
        disableChartType: [ChartType.Bar, ChartType.Line],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      digitalRevenue: {
        ...commonPCConsoleStatsConfig.digitalRevenue,
        disableChartType: [ChartType.Bar, ChartType.Line],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      physicalRevenue: {
        ...commonPCConsoleStatsConfig.physicalRevenue,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      steamData: {
        ...commonPCConsoleStatsConfig.steamData,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      japanSales: {
        ...commonPCConsoleStatsConfig.japanSales,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      newzoo: {
        ...commonPCConsoleStatsConfig.newzoo,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
    },
    countries: {
      pcu: {
        ...commonePCConsoleCountriesConfig.pcu,
      },
      gsd: {
        ...commonePCConsoleCountriesConfig.gsd,
        disableChartType: [],
      },
      digitalRevenue: {
        ...commonePCConsoleCountriesConfig.digitalRevenue,
        disableChartType: [],
      },
      physicalRevenue: {
        ...commonePCConsoleCountriesConfig.physicalRevenue,
        disableChartType: [ChartType.Pie],
      },
      steamData: {
        ...commonePCConsoleCountriesConfig.steamData,
        disableChartType: [],
      },
      japanSales: {
        ...commonePCConsoleCountriesConfig.japanSales,
        disableChartType: [ChartType.Pie],
      },
      newzoo: {
        ...commonePCConsoleCountriesConfig.newzoo,
        disableChartType: [],
      },
    },
  },
  console: {
    stats: {
      pcu: {
        ...commonPCConsoleStatsConfig.pcu,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      gsd: {
        ...commonPCConsoleStatsConfig.gsd,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      digitalRevenue: {
        ...commonPCConsoleStatsConfig.digitalRevenue,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      physicalRevenue: {
        ...commonPCConsoleStatsConfig.physicalRevenue,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      steamData: {
        ...commonPCConsoleStatsConfig.steamData,
        disableChartType: [ChartType.Bar, ChartType.Pie],
      },
      japanSales: {
        ...commonPCConsoleStatsConfig.japanSales,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
      newzoo: {
        ...commonPCConsoleStatsConfig.newzoo,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        pageSizeOptions: commonPageSizeOptions,
        // defaultPageSize: 5,
        defaultPageSize: 50,
      },
    },
    countries: {
      pcu: {
        ...commonePCConsoleCountriesConfig.pcu,
      },
      gsd: {
        ...commonePCConsoleCountriesConfig.gsd,
        disableChartType: [],
      },
      digitalRevenue: {
        ...commonePCConsoleCountriesConfig.digitalRevenue,
        disableChartType: [],
      },
      physicalRevenue: {
        ...commonePCConsoleCountriesConfig.physicalRevenue,
        disableChartType: [ChartType.Pie],
      },
      steamData: {
        ...commonePCConsoleCountriesConfig.steamData,
        disableChartType: [],
      },
      japanSales: {
        ...commonePCConsoleCountriesConfig.japanSales,
        disableChartType: [ChartType.Pie],
      },
      newzoo: {
        ...commonePCConsoleCountriesConfig.newzoo,
        disableChartType: [],
      },
    },
  },
  combine: {
    stats: {
      allMetrics: {
        sumavgArr: ['sum', 'avg' /* 'max',*/],
        chartIconList: commonIconList,
        defaultChartType: ChartType.Line,
        cardTitle: 'dbi_detail_trend',
        defaultByDeviceVal: false,
        disableChartType: [ChartType.Bar, ChartType.Pie],
        segementList: [],
        defaultSegmentVal: '',
        // 表格配置
        tableMetricList: [],
        firstCol: getStatsCommonFirstColConfig({
          sumInfo: 'dbi_ifno_mergesummax',
        }),
        specialCol: [],
        getMetricValueOfCvm: tableMetricValueOfCvm.common,
        pageSizeOptions: statsPageSizeOptions,
        getDefaultPageSize,
        tableSortMetricProperty: 'metric',
        tableSortGrowthProperty: 'growth_ratio',
        // 可视化配置
        lineMetricName: 'source',
        visualisLineTopChartsType: 'pcconsole-stats-line-pcu',
        lineSeriesFormatter:
          visualHandleLineFun.statsLineSeriesAllMetricFormatter,
        stackLineSeriesFormatter:
          visualHandleLineFun.digitalStatsStackLineSeriesFormatter,
        pieSeriesFormatter: () => {}, // TODO
        stackPieSeriesFormatter: () => {}, // TODO
      },
      pcu: {
        ...commonPCConsoleStatsConfig.pcu,
        cardTitle: '',
        disableChartType: [ChartType.StackedLine, ChartType.Bar, ChartType.Pie],
        defaultByDeviceVal: false,
        chartIconList: combineIconList,
        tableMetricList: steamPCUFollowerList,
        pageSizeOptions: statsPageSizeOptions,
        getDefaultPageSize,
        lineSeriesFormatter: (params: any) =>
          visualHandleLineFun.pcuStatsLineSeriesFormatter(
            params,
            steamPCUFollowerList,
          ),
        sumavgArr: ['sum', 'avg' /* 'max'*/],
        firstCol: getStatsCommonFirstColConfig({
          sumInfo: 'dbi_ifno_mergesummax',
        }),
      },
      gsd: {
        ...commonPCConsoleStatsConfig.gsd,
        disableChartType: [ChartType.Bar],
        defaultByDeviceVal: true,
        chartIconList: combineIconList,
        visualisLineTopChartsType: 'combine-stats-line',
        visualisPieTopChartsType: 'combine-stats-pie',
        pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
        // stackPieSeriesFormatter: visualHandleLineFun.commonStackPieSeriesFormatter,
        stackPieSeriesFormatter:
          visualHandleLineFun.getDeviceColorStackPieSeriesFormatter,
        stackLineSeriesFormatter:
          visualHandleLineFun.digitalStatsStackLineSeriesFormatterByDevice,
      },
      digitalRevenue: {
        ...commonPCConsoleStatsConfig.digitalRevenue,
        disableChartType: [ChartType.Bar],
        defaultByDeviceVal: true,
        chartIconList: combineIconList,
        visualisLineTopChartsType: 'combine-stats-line',
        visualisPieTopChartsType: 'combine-stats-pie',
        pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
        // stackPieSeriesFormatter: visualHandleLineFun.commonStackPieSeriesFormatter,
        stackPieSeriesFormatter:
          visualHandleLineFun.getDeviceColorStackPieSeriesFormatter,
        stackLineSeriesFormatter:
          visualHandleLineFun.digitalStatsStackLineSeriesFormatterByDevice,
      },
      physicalRevenue: {
        ...commonPCConsoleStatsConfig.physicalRevenue,
        disableChartType: [ChartType.Bar],
        defaultByDeviceVal: true,
        chartIconList: combineIconList,
        visualisPieTopChartsType: 'combine-stats-pie',
        visualisLineTopChartsType: 'combine-stats-line',
        pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
        stackPieSeriesFormatter:
          visualHandleLineFun.commonStackPieSeriesFormatter,
      },
      steamData: {
        ...commonPCConsoleStatsConfig.steamData,
        disableChartType: [ChartType.StackedLine, ChartType.Bar, ChartType.Pie],
        defaultByDeviceVal: false,
        chartIconList: combineIconList,
        visualisPieTopChartsType: 'combine-stats-pie',
        pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
        stackPieSeriesFormatter:
          visualHandleLineFun.commonStackPieSeriesFormatter,
      },
      consoleData: {
        ...commonPCConsoleStatsConfig.steamData,
        disableChartType: [ChartType.StackedLine, ChartType.Bar, ChartType.Pie],
        defaultByDeviceVal: false,
        chartIconList: combineIconList,
      },
      japanSales: {
        ...commonPCConsoleStatsConfig.japanSales,
        disableChartType: [ChartType.Bar],
        defaultByDeviceVal: true,
        chartIconList: combineIconList,
        visualisPieTopChartsType: 'combine-stats-pie',
        visualisLineTopChartsType: 'combine-stats-line',
        pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
        stackPieSeriesFormatter:
          visualHandleLineFun.commonStackPieSeriesFormatter,
      },
      newzoo: {
        ...commonPCConsoleStatsConfig.newzoo,
        disableChartType: [ChartType.Bar],
        defaultByDeviceVal: true,
        chartIconList: combineIconList,
        visualisPieTopChartsType: 'combine-stats-pie',
        visualisLineTopChartsType: 'combine-stats-line',
        pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
        stackPieSeriesFormatter:
          visualHandleLineFun.commonStackPieSeriesFormatter,
      },
    },
    // 通过指标传值过来，看是否是有，返回传的值；disableChartType也可以用同样的函数
    countries: {
      pcu: {
        ...commonePCConsoleCountriesConfig.pcu,
        cardTitle: '',
        disableChartType: [ChartType.Pie],
        defaultByDeviceVal: false,
        tableMetricList: steamPCUList,
        lineSeriesFormatter: (params: any) =>
          visualHandleLineFun.countriesPCULineSeriesFormatter(
            params,
            steamPCUList,
          ),
        barSeriesFormatter: (params: any) =>
          visualHandleLineFun.countriesPCUBarSeriesFormatter(
            params,
            steamPCUList,
          ),
        barNameListFormatter: () =>
          visualHandleLineFun.pcuBarNameListFormatter({ list: steamPCUList }),
      },
      gsd: {
        ...commonePCConsoleCountriesConfig.gsd,
        disableChartType: [],
        defaultByDeviceVal: true,
        stackBarSeriesFormatter:
          visualHandleLineFun.countriesDigitalRevenueStackBarSeriesFormatter,
      },
      digitalRevenue: {
        ...commonePCConsoleCountriesConfig.digitalRevenue,
        disableChartType: [],
        defaultByDeviceVal: true,
        // stackBarSeriesFormatter: visualHandleLineFun.commonStackBarSeriesFormatter,
        stackBarSeriesFormatter:
          visualHandleLineFun.countriesDigitalRevenueStackBarSeriesFormatter,
      },
      physicalRevenue: {
        ...commonePCConsoleCountriesConfig.physicalRevenue,
        disableChartType: [ChartType.Pie],
        defaultByDeviceVal: true,
        stackBarSeriesFormatter:
          visualHandleLineFun.commonStackBarSeriesFormatter,
      },
      steamData: {
        ...commonePCConsoleCountriesConfig.steamData,
        disableChartType: [],
        defaultByDeviceVal: false,
      },
      consoleData: {
        ...commonPCConsoleStatsConfig.consoleData,
        disableChartType: [ChartType.StackedLine, ChartType.Bar, ChartType.Pie],
        defaultChartType: ChartType.Line,
        defaultByDeviceVal: false,
        chartIconList: combineIconList,
        visualisLineTopChartsType: 'combine-stats-line',
      },
      consoleDataPlayersByCountry: {
        ...commonePCConsoleCountriesConfig.steamData,
        defaultChartType: ChartType.Bar,
        disableChartType: [ChartType.Line, ChartType.Pie, ChartType.StackedLine],
        cardTitle: 'dbi_detail_countries_share',
        defaultByDeviceVal: false,
        getMetricValueOfCvm: (cvm: any, metricKey: string) =>
          tableMetricValueOfCvm.countriesSteamSale(cvm, metricKey, 'name'),
      },
      japanSales: {
        ...commonePCConsoleCountriesConfig.japanSales,
        disableChartType: [ChartType.Pie],
        defaultByDeviceVal: true,
        stackBarSeriesFormatter:
          visualHandleLineFun.commonStackBarSeriesFormatter,
      },
      newzoo: {
        ...commonePCConsoleCountriesConfig.newzoo,
        disableChartType: [], // 每个指标可能不一样
        defaultByDeviceVal: true,
        stackBarSeriesFormatter:
          visualHandleLineFun.commonStackBarSeriesFormatter,
      },
      ampere: {
        ...commonePCConsoleCountriesConfig.ampere,
        disableChartType: [], // 每个指标可能不一样
        defaultByDeviceVal: true,
        stackBarSeriesFormatter:
          visualHandleLineFun.commonStackBarSeriesFormatter,
      },
    },
  },
} as any;

export const KPITrendsPageConfig = {
  sumavgArr: ['sum', 'avg' /* 'max',*/],
  chartIconList: commonIconList,
  defaultChartType: ChartType.Line,
  cardTitle: 'dbi_detail_trend',
  defaultByDeviceVal: false,
  disableChartType: [ChartType.Bar, ChartType.Pie],
  segementList: [],
  defaultSegmentVal: '',
  // 表格配置
  tableMetricList: [],
  firstCol: getStatsCommonFirstColConfig({ sumInfo: 'dbi_ifno_mergesummax' }),
  specialCol: [],
  getMetricValueOfCvm: tableMetricValueOfCvm.common,
  pageSizeOptions: statsPageSizeOptions,
  getDefaultPageSize,
  tableSortMetricProperty: 'metric',
  tableSortGrowthProperty: 'growth_ratio',
  // 可视化配置
  lineMetricName: 'source',
  visualisPieTopChartsType: 'combine-stats-pie',
  // visualisLineTopChartsType: 'pcconsole-stats-line-pcu',
  visualisLineTopChartsType: 'combine-stats-line',
  lineSeriesFormatter:
    visualHandleLineFun.statsLineSeriesAllMetricFormatter,
  pieSeriesFormatter: visualHandleLineFun.commonPieSeriesHoverFormatter,
  stackPieSeriesFormatter:
    visualHandleLineFun.getDeviceColorStackPieSeriesFormatter,
  stackLineSeriesFormatter:
    visualHandleLineFun.digitalStatsStackLineSeriesFormatterByDevice,
};

export const DETAIL_PAGEID = {
  overview: 'overview',
  allMetrics: 'allMetrics',
  pcu: 'pcu',
  physicalRevenue: 'physicalRevenue',
  gsd: 'gsd',
  digitalRevenue: 'digitalRevenue',
  steamData: 'steamData',
  consoleData: 'consoleData',
  consoleDataPlayersByCountry: 'consoleDataPlayersByCountry',
  japanSales: 'japanSales',
  newzoo: 'newzoo',
  ampere: 'ampere',
  gamalytic__pcu: 'gamalytic__pcu',
};

export const getDetailPageCfg = (
  pageId: string,
  tabType: 'countries' | 'stats',
  entityType = 'combine',
) => {
  return configurations?.[entityType]?.[tabType]?.[pageId] ?? {};
};
